var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.721374 0 0 0.721374 -0.369617 -1.0517)",
    stroke: "#000",
    xmlSpace: "preserve",
    textAnchor: "start",
    fontFamily: "Arial",
    fontSize: 20,
    id: "svg_1",
    y: 22.86569,
    x: 0.93873,
    strokeWidth: 0,
    fill: "#FFF"
  }, "En"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.f1eb40dcea713288dd55337124238017.svg";
export { ForwardRef as ReactComponent };